import { Plus } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { clearSelectedChampionship } from 'modules/championship/store/championship/actions';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UDButton from 'ud-ui/components/button';
import UDEmptyState from 'ud-ui/components/empty-state';

type Props = {
  className?: string;
  isFilterActive?: boolean;
  onResetFilters?: () => void;
};

const EmptyMessage = (props: Props) => {
  const { isFilterActive, onResetFilters } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCreateChampionshipClick = useCallback(() => {
    dispatch(clearSelectedChampionship());
    navigate(Pages.CHAMPIONSHIPS.CREATE);
  }, [dispatch, navigate]);

  const action = isFilterActive ? (
    <UDButton variant="secondary" className="flex flex-row items-center" onClick={onResetFilters}>
      {t('championships.emptyList.resetFilters')}
    </UDButton>
  ) : (
    <UDButton variant="primary" className="flex flex-row items-center" onClick={handleCreateChampionshipClick}>
      <Plus size={16} className="text-DarkBlue mr-2" />
      {t('championships.createTournamentButtonTitle')}
    </UDButton>
  );

  return (
    <UDEmptyState
      className={props.className}
      title={t(isFilterActive ? 'championships.emptyList.notFoundTitle' : 'championships.emptyList.title')}
      subtitle={t(isFilterActive ? 'championships.emptyList.notFoundBody' : 'championships.emptyList.body')}
      action={action}
    />
  );
};

export default EmptyMessage;
